import { Redirect } from "react-router-dom";
import Cookies from 'universal-cookie';
import * as Sentry from "@sentry/react";

function dispatches(inputs , workflow_id , user_name , code){

  run_github_action(inputs , workflow_id , user_name , code, "dispatches");

}

function delete_env(inputs , workflow_id , user_name , code){
  Sentry.withScope(scope => {
    scope.setExtra("env_name", inputs.env_name)
    Sentry.captureMessage(`delete env`, "info")
  });
  run_github_action(inputs , workflow_id , user_name , code, "delete_env");

}

function update_env(inputs , workflow_id , user_name , code){

  Sentry.withScope(scope => {
    scope.setExtra("env_name", inputs.env_name)
    Sentry.captureMessage(`update env - ${workflow_id}`, "info")
  });
  run_github_action(inputs , workflow_id , user_name , code, "update_env");

}


async function create_new_env(inputs , workflow_id , user_name , code){

  Sentry.withScope(scope => {
    scope.setExtra("env_name", inputs.domain)
    Sentry.captureMessage(`create new env`, "info")
  });
  run_github_action(inputs , workflow_id , user_name , code, "create_env");

}

function add_front(inputs , workflow_id , user_name , code){

  Sentry.withScope(scope => {
    scope.setExtra("env_name", inputs.env_name)
    Sentry.captureMessage(`add front`, "info")
  });
  // Sentry.captureMessage(`add front `, "info");
  run_github_action(inputs , workflow_id , user_name , code, "add_front");

}

function run_github_action(inputs , workflow_id , user_name , code, action_id){

  const cookies = new Cookies();
  var options = {
    'method': 'POST',
    'url': process.env.REACT_APP_INFRA_SERVICE_URL+`/github/${action_id}/` ,
    'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "code": code,
      "repo": "infra-api",
      "user_name" : user_name , 
      "workflow_id":  workflow_id ,
      "githubRef":  "workiz.com" ,
      "inputs": inputs
    })
  };
  fetch(process.env.REACT_APP_INFRA_SERVICE_URL+`/github/${action_id}/` , options).then(response=>response.json())
  .then(async data=>{ 
      if (data.statusCode>200){
        cookies.remove("code");
        return <Redirect to="/login" />;
      }
    });
  
}

function valid_domain_name(domain){
  if(domain=="rc")
    return false
  let reg = /^[a-z0-9]+$/
  if(reg.test(domain)) 
    {
      return true;
    }
  else 
    {
      return false;
    }
}

function domain_exists(domain,all_envs){
  if(all_envs.includes(domain))
    return true
  else
    return false
}

function valid(s){
  let reg = /^[A-Za-z0-9\-\_\:\/\.\#ֿֿֿֿ\@\+\/\&\?\=]+$/
  return reg.test(s);
}

export default {dispatches, delete_env, create_new_env, update_env, valid_domain_name,add_front , domain_exists , valid }